/** Run an agent on many items (ADR-0107). */
export default {
  en: {
    title: "Run on many items",
    subtitle: "Run an agent once for every row of a CSV file or a data table — with progress, each row's result, a cost limit and a download.",
    new: "New bulk run",
    none: "No bulk runs yet. Start one to run an agent over a list, e.g. every overdue invoice.",
    pick: "Choose a bulk run to see its rows.",
    agent: "Agent",
    agentPick: "Choose an agent released to people",
    version: "Version {{version}} ({{where}})",
    where: { prod: "in production", dev: "in development" },
    name: "Name of this bulk run (optional)",
    from: "The rows",
    fromCsv: "A CSV file",
    fromTable: "A data table",
    csvFile: "CSV file",
    csvRead: "{{count}} rows, columns: {{columns}}",
    csvCut: "This file has more than 5,000 rows. Split it, or run the agent from a system query with a ‘For each item’ step.",
    table: "Data table",
    tablePick: "Choose a data table",
    question: "What the agent is asked for each row",
    questionHelp: "Use {Column} for a row's value, e.g. Remind {customer} of invoice {invoice}. Empty: the row's values, “column: value; …”.",
    concurrency: "Rows at the same time",
    cap: "The most this may cost (US$)",
    capHelp: "Up to {{each}} a row by the agent's budget: at most {{total}} for {{rows}} rows. Rows not started when the limit is reached are marked ‘not run’.",
    start: "Start",
    cancel: "Cancel",
    started: "Started: {{count}} rows.",
    status: { running: "Running", finished: "Finished", stopped: "Stopped at the cost limit", cancelled: "Stopped" },
    rowStatus: { waiting: "Waiting", running: "Running", done: "Done", failed: "Failed", not_run: "Not run" },
    all: "All rows",
    progress: "{{done}} done · {{failed}} failed · {{not_run}} not run · {{waiting}} waiting (of {{total}})",
    cost: "Spent {{spent}} of {{cap}}",
    reason: "Why it stopped: {{reason}}",
    retry: "Try the failed rows again",
    retried: "{{rows}} rows are being tried again.",
    stop: "Stop starting rows",
    stopConfirm: "Stop this bulk run? Rows already running finish; the rest are marked ‘not run’.",
    stopping: "Stopping: no more rows start.",
    download: "Download results (CSV)",
    row: "Row",
    input: "Values",
    result: "Result",
    statusCol: "How it went",
    openRun: "See the run",
    by: "Started by {{who}} · {{when}}",
    source: { csv: "CSV file", rows: "Rows from a program", table: "Data table ‘{{name}}’" },
    issues: {
      agent_required: "Choose an agent.",
      rows_required: "Choose a CSV file or a data table with rows.",
      cap_required: "Set the most this may cost.",
      too_many: "At most 5,000 rows.",
    },
    yes: "Stop",
    no: "Keep running",
  },
  ar: {
    title: "التشغيل على عناصر كثيرة",
    subtitle: "شغّل وكيلاً مرة لكل صف من ملف CSV أو جدول بيانات — مع التقدّم ونتيجة كل صف وحدّ للتكلفة وتنزيل.",
    new: "تشغيل جماعي جديد",
    none: "لا توجد تشغيلات جماعية بعد. ابدأ واحداً لتشغيل وكيل على قائمة، مثل كل فاتورة متأخرة.",
    pick: "اختر تشغيلاً جماعياً لترى صفوفه.",
    agent: "الوكيل",
    agentPick: "اختر وكيلاً مُطلقاً للأشخاص",
    version: "الإصدار {{version}} ({{where}})",
    where: { prod: "في الإنتاج", dev: "في التطوير" },
    name: "اسم هذا التشغيل الجماعي (اختياري)",
    from: "الصفوف",
    fromCsv: "ملف CSV",
    fromTable: "جدول بيانات",
    csvFile: "ملف CSV",
    csvRead: "{{count}} صفاً، الأعمدة: {{columns}}",
    csvCut: "في هذا الملف أكثر من 5,000 صف. قسّمه، أو شغّل الوكيل من استعلام نظام بخطوة «لكل عنصر».",
    table: "جدول البيانات",
    tablePick: "اختر جدول بيانات",
    question: "ما يُسأل عنه الوكيل لكل صف",
    questionHelp: "استخدم {Column} لقيمة من الصف، مثل: ذكّر {customer} بالفاتورة {invoice}. فارغ: قيم الصف «العمود: القيمة؛ …».",
    concurrency: "صفوف في الوقت نفسه",
    cap: "أقصى تكلفة (دولار أمريكي)",
    capHelp: "حتى {{each}} للصف حسب ميزانية الوكيل: {{total}} على الأكثر لـ{{rows}} صفاً. الصفوف التي لم تبدأ عند بلوغ الحد تُعلَّم «لم يُنفَّذ».",
    start: "ابدأ",
    cancel: "إلغاء",
    started: "بدأ: {{count}} صفاً.",
    status: { running: "قيد التشغيل", finished: "انتهى", stopped: "توقف عند حد التكلفة", cancelled: "أُوقف" },
    rowStatus: { waiting: "بالانتظار", running: "قيد التشغيل", done: "تم", failed: "فشل", not_run: "لم يُنفَّذ" },
    all: "كل الصفوف",
    progress: "{{done}} تم · {{failed}} فشل · {{not_run}} لم يُنفَّذ · {{waiting}} بالانتظار (من {{total}})",
    cost: "أُنفق {{spent}} من {{cap}}",
    reason: "سبب التوقف: {{reason}}",
    retry: "إعادة محاولة الصفوف الفاشلة",
    retried: "تُعاد محاولة {{rows}} صفاً.",
    stop: "إيقاف بدء الصفوف",
    stopConfirm: "إيقاف هذا التشغيل الجماعي؟ تكتمل الصفوف الجارية؛ وتُعلَّم البقية «لم يُنفَّذ».",
    stopping: "يتوقف: لن تبدأ صفوف أخرى.",
    download: "تنزيل النتائج (CSV)",
    row: "الصف",
    input: "القيم",
    result: "النتيجة",
    statusCol: "الحال",
    openRun: "عرض التشغيل",
    by: "بدأه {{who}} · {{when}}",
    source: { csv: "ملف CSV", rows: "صفوف من برنامج", table: "جدول البيانات ‹{{name}}›" },
    issues: {
      agent_required: "اختر وكيلاً.",
      rows_required: "اختر ملف CSV أو جدول بيانات فيه صفوف.",
      cap_required: "حدّد أقصى تكلفة.",
      too_many: "5,000 صف على الأكثر.",
    },
    yes: "إيقاف",
    no: "متابعة التشغيل",
  },
};
